function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, cloneElement } from "react";
import { floral } from "@thebouqs/system";
import { Overlay } from "@thebouqs/overlay";
// Allows us to serve a page with a visible modal which can be closed, meant for SEO/bots
export var UncontrolledModal = /*#__PURE__*/forwardRef((props, ref) => {
  var cleanedProps = {};
  Object.assign(cleanedProps, props, {
    onClose: undefined,
    display: undefined,
    alignTo: undefined
  });
  var {
    children,
    id,
    CloseButton,
    sx,
    label,
    mainProps,
    contentProps,
    closeButtonProps
  } = cleanedProps;

  var mainRest = _objectWithoutPropertiesLoose(mainProps, ["style"]);

  var onClose = () => {
    window.location.hash = "";
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(floral.div, _extends({
    ref: ref,
    "aria-label": label,
    tabIndex: 0,
    sx: _extends({}, sx == null ? void 0 : sx.dialog, {
      display: "block"
    })
  }, mainRest), /*#__PURE__*/cloneElement(CloseButton, _extends({
    onClick: onClose,
    as: "a",
    href: "#",
    stylesOverride: sx == null ? void 0 : sx.closeButton
  }, closeButtonProps)), /*#__PURE__*/React.createElement(floral.div, _extends({
    sx: _extends({}, sx.body)
  }, contentProps), children)));
});
export var ControlledModal = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    onClose,
    children,
    CloseButton,
    sx,
    label,
    alignTo,
    mainProps,
    contentProps,
    closeButtonProps
  } = props;

  var {
    style
  } = mainProps,
      mainRest = _objectWithoutPropertiesLoose(mainProps, ["style"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClose,
    alignTo: alignTo
  }), /*#__PURE__*/React.createElement(floral.div, _extends({
    ref: ref,
    "aria-label": label,
    sx: _extends({}, sx.dialog, style)
  }, mainRest), /*#__PURE__*/cloneElement(CloseButton, _extends({
    onClick: onClose,
    stylesOverride: sx == null ? void 0 : sx.closeButton
  }, closeButtonProps), null), /*#__PURE__*/React.createElement(floral.div, _extends({
    sx: _extends({}, sx.body)
  }, contentProps), children)));
});
var ModalMain = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    children,
    open,
    controlled
  } = props,
      _modalprops = _objectWithoutPropertiesLoose(props, ["children", "open", "controlled"]);

  var modalprops = _objectWithoutPropertiesLoose(_modalprops, ["ref"]); //in case JS is disabled, should be served in a container that holds an inbound link target


  if (!controlled) {
    return /*#__PURE__*/React.createElement(UncontrolledModal, _extends({
      ref: ref
    }, modalprops), children);
  } // if JS is enabled, use the controlled component


  return /*#__PURE__*/React.createElement(React.Fragment, null, open ? /*#__PURE__*/React.createElement(ControlledModal, _extends({
    ref: ref
  }, modalprops), children) : null);
});
export default ModalMain;
//# sourceMappingURL=ModalMain.js.map